import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useConfigurationState } from 'z3k-settings/climatic/configuration/lib/useConfigurationState';
import { HeatingCard } from 'z3k-settings/climatic/configuration/ui/heating-card';
export function HeatingList() {
    const { circuits } = useConfigurationState();
    return (_jsx(SettingCard, { title: "\u041A\u043E\u043D\u0442\u0443\u0440\u044B \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F", children: circuits.map((circuit, i) => {
            if (!circuit.isIOExtensionCircuit)
                return (_jsx(HeatingCard, { number: i + 1, heating_settings: circuit }, circuit.id));
            return null;
        }) }));
}
